import { render } from "./Unauthorized.vue?vue&type=template&id=0b07f4de"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import "./Unauthorized.vue?vue&type=style&index=0&id=0b07f4de&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__